import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AemService, CommonService, J4uV1Service, UserInfoService } from 'abs-ngx-library/src/lib/core';
import { PageFlags } from 'src/app/shared/models/pageFlags.model';
import { LogService } from 'src/app/shared/services/log.service';

interface Offer {
  offerId?: string;
  offerPgm?: string;
}
@Component({
  selector: 'app-offer-details-page',
  templateUrl: './offer-details-page.component.html',
  styleUrls: ['./offer-details-page.component.scss'],
})
export class OfferDetailsPageComponent implements OnInit {
  public windowObj: any = window;
  userInfo: any;
  _window: any = window;
  public coupon: Offer = {};
  public configObj: any = {
    appName: 'b4u-offerDetails',
    bannerDomain: '',
  };
  public dataValue: object = {'c-products-by-upc':{'offerId':''}};
  public pageFlags: PageFlags = {
    isBonusPathPage: false,
    isCouponsDealsPage: false,
    isOfferDetailsPage: true
  };
  public catalogApiUrl: string = '';
  public logoProps: any;
  public index: any = 26;
  public isOfferDetailsDispBannerDisabled = false;
  public categoryName: string = '';
  public isUserLoggedIn: boolean = false;

  constructor(
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    private userInfoService: UserInfoService,
    private commonService: CommonService,
    private _j4uAlV1Service: J4uV1Service,
    private absAemService: AemService,
    private _logService: LogService
  ) {
    let offerDetailsPageSortOptions: any = [ "price-low-high", "search-rank", "most-popular" ];
    let offerDetailsPafeDefaultSortOptions: string = "most-popular";
    this._window['AB']['availableSorts'] = offerDetailsPageSortOptions;
    this._window['AB']['defaultSort'] = offerDetailsPafeDefaultSortOptions;
    this.activeRoute.data.subscribe(
      (data: any) => {
        let isSessionValid = this.authService.isTokenValidForSession(
          data.tokenObject
        );
        const sessionData = {
          ...data.tokenObject,
          authToken: data.tokenObject['SWY_SHOP_TOKEN'],
        };
        if (sessionData.siteType === 'B') {
          sessionData['j4uStoreId'] = sessionData.storeId;
          sessionData['shopStoreId'] = sessionData.storeId;
        }
        if (isSessionValid) {
          if (sessionData) {
            this.userInfo = sessionData;
            // this._window['AB'].userInfo = { ...sessionData };
            this.authService.updateUserInfo(sessionData);
            this.userInfoService.setUserSession(sessionData);
            this.commonService.postUserInfoSource.next('initFunc');
            this.commonService._postUserInfoSource.next('initFunc');
            this.isUserLoggedIn = true;
          }
        } else {
          // this.authService.redirectToSSO(data.tokenObject);
          this.authService.updateUserInfo(sessionData);
          this.userInfoService.setUserSession(data.tokenObject);
        }
      },
      (err) => {
        this.authService.redirectToSSO({});
      }
    );
  }

  ngOnInit(): void {
    this._j4uAlV1Service
      .getLogoList()
      .subscribe((data: any) => (this.logoProps = data));
    if (window.location.href.includes('local')) {
      this.configObj['bannerDomain'] = 'https://www-qa1.safeway.com';
    }
    if (this._window['AB'] && this._window['AB']['DATALAYER']) {
      this._window['AB']['DATALAYER'].initAngularSPA();
    }
    console.warn(window.location.pathname);
    const offerDetailPath = window.location.pathname?.split('/');
    // const offerData = offerDetailPath?.split('.');
    // if (offerData && offerData[1])
    this.coupon.offerId = offerDetailPath[3].toString();
    // if (offerData && offerData[3])
    this.coupon.offerPgm = offerDetailPath[4].toString();
    this.dataValue = {'c-products-by-upc':{'offerId': this.coupon.offerId}};
    this.catalogApiUrl = this._window['AB']['catalogXapiProductsUpcEndpoint'];
    // setTimeout(() => {
    //   this._logService.logRoundTrip();
    // },2000);
  }

  // Called when offer API will return categoryName
  onGetOffer(categoryName: string) {
    this.isOfferDetailsDispBannerDisabled = this.absAemService.getFeatureFlagByNameDisable('isOfferDetailsDispBannerDisabled');
    if(!this.isOfferDetailsDispBannerDisabled && categoryName) {
      this.categoryName = categoryName;
    }
  }

  ngOnDestroy(): void {
    const searchInput = document.querySelector('.search-nav__input') as HTMLInputElement;
    searchInput.value = '';
  }
}
